export default __webpack_public_path__ + "static/media/pot6.f6d0fd10.svg";